/**
 * ATW Greek uppercase typography
 * Greek typographic convention: words set in ALL CAPS do not keep tonos.
 * We only remove tonos from Greek text nodes whose computed text-transform is uppercase.
 * Diaeresis is preserved (ϊ/ϋ -> Ϊ/Ϋ visually through CSS uppercase).
 */
(() => {
  const accentedGreek = /[άέήίόύώΆΈΉΊΌΎΏΐΰ]/g;
  const map = {
    'ά':'α','έ':'ε','ή':'η','ί':'ι','ό':'ο','ύ':'υ','ώ':'ω',
    'Ά':'Α','Έ':'Ε','Ή':'Η','Ί':'Ι','Ό':'Ο','Ύ':'Υ','Ώ':'Ω',
    'ΐ':'ϊ','ΰ':'ϋ'
  };

  const stripGreekTonos = (value) =>
    value.normalize('NFC').replace(accentedGreek, (char) => map[char] || char);

  const shouldSkip = (element) =>
    !element ||
    element.closest('script, style, textarea, input, select, option, [contenteditable="true"]');

  const fixTextNode = (node) => {
    const parent = node.parentElement;
    if (shouldSkip(parent)) return;

    const value = node.nodeValue;
    if (!value || !accentedGreek.test(value)) {
      accentedGreek.lastIndex = 0;
      return;
    }
    accentedGreek.lastIndex = 0;

    if (getComputedStyle(parent).textTransform !== 'uppercase') return;

    const fixed = stripGreekTonos(value);
    if (fixed !== value) node.nodeValue = fixed;
  };

  const fixRoot = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      fixTextNode(root);
      return;
    }

    if (!(root instanceof Element || root instanceof Document || root instanceof DocumentFragment)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) fixTextNode(node);
  };

  const run = () => fixRoot(document.body);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'characterData') {
        fixTextNode(mutation.target);
        continue;
      }
      for (const node of mutation.addedNodes) fixRoot(node);
    }
  });

  const observe = () => {
    if (!document.body) return;
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }
})();
